import React, { useMemo } from "react";
import { FieldArray } from "react-final-form-arrays";
import { useFormState } from "react-final-form";
import { get } from "lodash";
import ParameterSection from "./components/ParameterSection";
import { FormFields as OptimizationFormFields } from "../../index";
import ScrollBar from "components/ScrollBar";
import * as styles from "./styles.module.scss";
export const MAX_PARAMETERS = 8;
export var FormFields;
(function (FormFields) {
    FormFields["parameters"] = "parameters";
})(FormFields || (FormFields = {}));
export var ParameterFormFields;
(function (ParameterFormFields) {
    ParameterFormFields["stepId"] = "stepId";
    ParameterFormFields["parameterId"] = "parameterId";
    ParameterFormFields["_flowIdsSelection"] = "_flowIdsSelection";
    ParameterFormFields["_flowIdsMapping"] = "_flowIdsMapping";
    ParameterFormFields["flowIds"] = "flowIds";
    ParameterFormFields["min"] = "min";
    ParameterFormFields["max"] = "max";
    ParameterFormFields["notSaved"] = "notSaved";
})(ParameterFormFields || (ParameterFormFields = {}));
export const checkSomeParameterNotSaved = (parameters) => !!parameters?.some((parameter) => parameter?.parameters?.some(({ notSaved }) => !!notSaved));
const ParametersToOptimize = ({ restrictions }) => {
    const formValues = useFormState()?.values;
    const maxParametersReached = useMemo(() => (formValues?.state?.parameters?.reduce((acc, item) => [...acc, ...(item?.parameters ?? [])], []).length ?? 0) >= MAX_PARAMETERS, [formValues?.state?.parameters]);
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement(ScrollBar, { className: styles.scrollBar },
            React.createElement("div", { className: styles.root },
                React.createElement(FieldArray, { name: OptimizationFormFields.state_parameters, render: (renderProps) => {
                        const { fields = [] } = renderProps;
                        const parametersSections = ["", "", ""];
                        fields.forEach((parametersSection, index) => (parametersSections[index] = parametersSection));
                        return parametersSections.map((name, index) => (React.createElement(ParameterSection, { key: `${name}-${index}-${renderProps.fields.length}`, name: name || `${OptimizationFormFields.state_parameters}[${index}]`, input: get(formValues, OptimizationFormFields.state_input, {}), renderProps: renderProps, index: index, maxParametersReached: maxParametersReached, restrictions: restrictions })));
                    } })))));
};
export default ParametersToOptimize;
